export default {
  items: [
    {
      title: 'tasks.nav.title',
      id: 'Tasks',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'tasks.nav.title',
          to: { name : 'TasksIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
